import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useEventSanctioned = () => {
  const [isSanctioned, setIsSanctioned] = useState(false);
  const { data: periodPenalties } = useSelector(
    (state: any) => state.eventPenalties
  );

  // const { data: dataExternalSettings } = useSelector(
  //   (state: any) => state.externalSettings
  // );

  const { data: dataPeriods } = useSelector((state: any) => state.getPeriods);
  const currentPeriod = dataPeriods?.find((p: any) => !!p.isCurrent);

  useEffect(() => {
    if (periodPenalties && dataPeriods) {
      setIsSanctioned(periodPenalties.includes(currentPeriod?.period));
    }
  }, [periodPenalties, dataPeriods]);

  return isSanctioned;
};

export default useEventSanctioned;
